export default {
  'Submit screening results': 'إرسال نتائج الفحص',
  'Would you like to submit screening results?': 'هل ترغب في تقديم نتائج الفحص؟',

  // Review Summary Page
  ' Review Summary Page': 'صفحة ملخص المراجعة',
  'Review Summary Page': 'صفحة ملخص المراجعة',

  // Screening tab labels
  'Screening Results': 'نتائج الفحص',
  Status: 'الحالة',

  'screeningResolution.NO_MATCHES': 'لا يوجد تطابق',
  'screeningResolution.FULL_MATCH': 'تطابق كامل',
  'screeningResolution.PARTIAL_MATCH': 'تطابق جزئي',
  'screeningResolution.MATCH': 'تطابق',
  'screeningResolution.ERROR': 'خطأ',
  'reviewResult.APPROVED': 'موافق عليه',
  'reviewResult.RESUBMIT': 'إعادة تقديم',
  'reviewResult.DECLINED': 'مرفوض',

  // Company Information step
  'Company Information': 'معلومات الشركة',
  'Company details': 'تفاصيل الشركة',
  'Company Legal name': 'الاسم القانوني للشركة',
  'Company commercial name': 'الاسم التجاري للشركة',
  'Company Legal type': 'نوع الشركة القانوني',
  'Company legal type': 'نوع الشركة القانوني',
  'Date of establishment': 'تاريخ التأسيس',
  'Commercial registration number': 'رقم السجل التجاري',
  'Commercial Entity number': 'رقم السجل التجاري',
  'Commercial entity number': 'رقم السجل التجاري',
  'Main Cr National Number': 'الرقم الوطني للسجل الرئيسي',
  'License issue date': 'تاريخ إصدار الترخيص',
  'License expiry date': 'تاريخ انتهاء الترخيص',
  'Parent company license number': 'رقم ترخيص الشركة الأم',
  Capital: 'رأس المال',
  'Paid amount': 'المبلغ المدفوع',
  'Announced amount': 'المبلغ المعلن',
  'Subscribed amount': 'المبلغ المكتتب به',
  'Shares count': 'عدد الأسهم',
  'Share price': 'سعر السهم',
  'Fiscal year': 'السنة المالية',
  'Day and month': 'اليوم والشهر',
  'Calendar type': 'نوع التقويم',
  Activities: 'الأنشطة',
  'Main activity': 'النشاط الرئيسي',
  ISIC: 'ISIC',
  'Tax registration certificate': 'شهادة التسجيل الضريبي',
  'Merchant have Tax registration certificate': 'لدى التاجر شهادة تسجيل ضريبي',
  'Tax registration certificate photo': 'صورة شهادة التسجيل الضريبي',
  'Tax registration number': 'رقم التسجيل الضريبي',
  'E-commerce merchant': 'التجارة الإلكترونية',
  'Company period (in years)': 'الفترة الشركة (بالسنوات)',
  'Date of closing': 'تاريخ الإنتهاء',
  'Main business nature category': 'فئة طبيعة العمل الرئيسية',
  'Main business nature': 'طبيعة العمل الرئيسية',
  'Business nature category': 'فئة طبيعة العمل',
  'Business nature (MCC code)': 'طبيعة العمل (رمز مركز عملائي)',

  // Address step
  Address: 'العنوان',
  Country: 'الدولة',
  Location: 'الموقع',
  'Address line': 'سطر العنوان',
  'P.O. Box': 'صندوق بريد',
  'Office phone number': 'رقم هاتف المكتب',
  'Fax number': 'رقم الفاكس',
  'Additional phone number': 'رقم هاتف إضافي',
  'Additional fax number': 'رقم فاكس إضافي',
  City: 'مدينة',
  'Company email': 'البريد الإلكتروني للشركة',
  'Merchant wants to change a business address': 'يريد التاجر تغيير عنوان العمل',

  // Bank Account step
  'Bank account': 'حساب البنك',
  'Account for E-commerce': 'حساب للتجارة الإلكترونية',
  'Please upload a scan of stamped IBAN letter.': 'يرجى إرفاق نسخة من خطاب IBAN المختوم.',
  'IBAN letter': 'خطاب IBAN',
  'Beneficiary name': 'اسم المستفيد',
  'Beneficiary name – Agent Updates': 'اسم المستفيد – تحديثات الوكيل',
  'Please enter the English beneficiary name': 'يرجى إدخال اسم المستفيد باللغة الإنجليزية',
  'Bank name (Lean verified)': 'اسم البنك (تم التحقق عبر Lean)',
  'Bank name – Agent Updates': 'اسم البنك – تحديثات الوكيل',
  'Please enter the English bank name': 'يرجى إدخال اسم البنك باللغة الإنجليزية',
  IBAN: 'IBAN',
  'Bank name': 'اسم البنك',
  'Bank SWIFT code': 'رمز SWIFT للبنك',
  'Is Verified ?': 'هل تم التحقق؟',
  'Verification Status': 'حالة التحقق',
  'Derived Bank Name': 'اسم البنك المستنتج',
  'Derived Swift Code': 'رمز سويفت المستنتج',
  'IBAN – Agent Updates': 'رقم الآيبان – تحديثات الوكيل',
  'Swift Code – Agent Updates': 'رمز سويفت – تحديثات الوكيل',
  'English letters and spaces only': 'الحروف الإنجليزية والمسافات فقط',
  'Please enter the IBAN': 'يرجى إدخال رقم الآيبان',
  'Please enter the Swift Code': 'يرجى إدخال رمز سويفت',
  'Enter a valid 8 or 11 character Swift Code': 'أدخل رمز سويفت صالحًا مكونًا من 8 أو 11 حرفًا',
  'IBAN must be SA followed by 22 digits': 'يجب أن يبدأ رقم الآيبان بـ SA متبوعة بـ 22 رقمًا',
  'IBAN invalid length': 'يجب أن يتكون رقم الآيبان من 24 خانة بالضبط',
  'IBAN must start with SA': 'يجب أن يبدأ رقم الآيبان بـ "SA"',
  'IBAN check digits invalid': 'يجب أن تكون خانتا التحقق (الخانتان 3 و4) أرقامًا',
  'IBAN body must be alphanumeric': 'يجب أن تكون خانات البنك والحساب (الخانات 5-24) أحرفًا أو أرقامًا',
  'IBAN checksum invalid': 'مجموع التحقق للآيبان غير صحيح — يرجى التحقق وإعادة الإدخال',

  // Risk Team Fields – Company Information Agent Updates
  'Main CR Number – Agent Updates': 'رقم السجل الرئيسي – تحديثات الوكيل',
  'CR Number – Agent Updates': 'رقم السجل التجاري – تحديثات الوكيل',
  'CR Status – Agent Updates': 'حالة السجل التجاري – تحديثات الوكيل',
  'Enter CR status': 'أدخل حالة السجل التجاري',
  'Confirmation Date – Agent Updates': 'تاريخ التأكيد – تحديثات الوكيل',
  'Expiry / Suspension Date – Agent Updates': 'تاريخ الانتهاء / التعليق – تحديثات الوكيل',
  'Applicant Phone Number – Agent Updates': 'رقم هاتف مقدم الطلب – تحديثات الوكيل',
  'Enter applicant mobile number': 'أدخل رقم هاتف مقدم الطلب',
  'Fax Number – Agent Updates': 'رقم الفاكس – تحديثات الوكيل',
  'Postal Code – Agent Updates': 'الرمز البريدي – تحديثات الوكيل',
  'Website URL – Agent Updates': 'رابط الموقع – تحديثات الوكيل',
  'Electronic Website – Agent Updates': 'الموقع الإلكتروني – تحديثات الوكيل',
  'Enter electronic website URL': 'أدخل رابط الموقع الإلكتروني',
  'City – Agent Updates': 'المدينة – تحديثات الوكيل',
  'Capital Amount – Agent Updates': 'مبلغ رأس المال – تحديثات الوكيل',
  'Calendar Type – Agent Updates': 'نوع التقويم – تحديثات الوكيل',
  'Calendar Type': 'نوع التقويم',
  'Day & Month': 'اليوم والشهر',
  'DD/MM': 'يي/شش',
  'Please enter the day & month': 'يرجى إدخال اليوم والشهر',
  'Please enter the calendar type': 'يرجى إدخال نوع التقويم',

  // Risk Team Fields – Address Agent Updates
  'Office phone number – Agent Updates': 'رقم هاتف المكتب – تحديثات الوكيل',
  'Fax number – Agent Updates': 'رقم الفاكس – تحديثات الوكيل',
  'P.O. Box – Agent Updates': 'صندوق البريد – تحديثات الوكيل',
  'National Address – Agent Updates': 'العنوان الوطني – تحديثات الوكيل',
  'National Address – Building Number': 'العنوان الوطني – رقم المبنى',
  'National Address – Additional Number': 'العنوان الوطني – الرقم الإضافي',
  'National Address – Unit Number': 'العنوان الوطني – رقم الوحدة',
  'National Address – Street Name': 'العنوان الوطني – اسم الشارع',
  'National Address – District Name': 'العنوان الوطني – اسم الحي',
  'Regular Address – Agent Updates': 'العنوان العادي – تحديثات الوكيل',

  // Risk Team Fields – Managers / Shareholders Agent Updates
  'Date of birth – Agent Updates': 'تاريخ الميلاد – تحديثات الوكيل',
  'ID Type': 'نوع الهوية',
  'ID Number – Agent Updates': 'رقم الهوية – تحديثات الوكيل',
  'Shares % – Agent Updates': 'نسبة الأسهم % – تحديثات الوكيل',
  'Shares count – Agent Updates': 'عدد الأسهم – تحديثات الوكيل',
  'Share Type – Agent Updates': 'نوع الحصة – تحديثات الوكيل',
  'Entity Relationship Type – Agent Updates': 'نوع علاقة الكيان – تحديثات الوكيل',
  'Share Value': 'قيمة الحصة',
  'Enter share value': 'أدخل قيمة الحصة',

  // Missing/Wrong Retrieved Data
  'Missing Value': 'قيمة مفقودة',
  'Arabic Value': 'قيمة عربية',
  'Missing/Wrong Retrieved Data': 'بيانات مفقودة أو غير صحيحة',
  'No missing or incorrect retrieved fields detected.': 'لم يتم اكتشاف أي حقول مفقودة أو غير صحيحة.',
  'The following fields retrieved from Thiqah or Lean have missing or Arabic values and require agent updates:':
    'الحقول التالية المسترجعة من ثقة أو Lean تحتوي على قيم مفقودة أو عربية وتتطلب تحديثات من الوكيل:',

  // Company Questionnaire step
  'Company Questionnaire': 'استبيان الشركة',
  'Company website URL': 'عنوان موقع الشركة',
  'Number of employees': 'عدد الموظفين',
  'The reason for applying for payment services': 'سبب التقدم بطلب خدمات الدفع',
  'Do you have any established branch?': 'هل لديك أي فرع قائم؟',
  Yes: 'نعم',
  No: 'لا',
  'Do you require tokenization?': 'هل تحتاج إلى خدمة تشفير البطاقات؟',
  'Expected turnover': 'المبيعات المتوقعة',
  'Financial performance and projection': 'الأداء المالي والتوقعات',
  'These are the values in SAR of expected financial performance':
    'هذه هي القيم بالريال السعودي للأداء المالي المتوقع',
  'Expected average per transaction': 'المتوسط المتوقع لكل عملية',
  'Expected average per month': 'المتوسط المتوقع شهريًا',
  'Expected six-month average credit balance': 'متوسط رصيد الائتمان المتوقع لمدة ستة أشهر',
  'Expected sales value turnover per year': 'قيمة المبيعات المتوقعة سنويًا',
  'Expected number of transactions': 'عدد العمليات المتوقعة',
  'These are the numbers of expected turnover': 'هذه هي أرقام المبيعات المتوقعة',
  'Expected monthly transactions': 'عدد العمليات الشهرية المتوقعة',
  'Expected sales volume turnover per year': 'حجم المبيعات المتوقع سنويًا',
  declaration: 'الإقرار',
  'Do you hold any position from the below list of categories?':
    'هل تشغل أي منصب من قائمة الفئات التالية؟',
  'Is your company registered or incorporated in a sanctioned country?':
    'هل شركتك مسجلة أو مدمجة في دولة خاضعة للعقوبات؟',
  'Does your company own any assets in a sanctioned country?':
    'هل تملك شركتك أي أصول في دولة خاضعة للعقوبات؟',
  'Additional documents': 'مستندات إضافية',
  'Sama License Photo': 'صورة رخصة سمة',
  'Sama License Number': 'رقم رخصة سمة',
  'AML policy and procedure document': 'مستند سياسة وإجراءات مكافحة غسيل الأموال',
  'Number of AML policy and procedure document': 'عدد مستند سياسة وإجراءات مكافحة غسيل الأموال',
  'Compliance Clearance Certificate photo': 'صورة شهادة إتمام الامتثال',
  'Compliance Clearance Certificate number': 'رقم شهادة إتمام الامتثال',

  // Complete review step
  'Complete Application review ': 'مراجعة التطبيق المكتمل',
  Proceed: 'متابعة',
  Cancel: 'إلغاء',
  Approve: 'الموافقة',
  Resubmit: 'إعادة تقديم',
  Decline: 'رفض',
  'Would you like to complete application review and submit your results?':
    'هل ترغب في استكمال مراجعة التطبيق وإرسال نتائجك؟',
  'Complete review': 'استكمال المراجعة',
  'Decision on the application': 'قرار بشأن التطبيق',
  'Correct review data': 'تصحيح بيانات المراجعة',
  'Complete all steps to submit review': 'استكمال جميع الخطوات لإرسال المراجعة',
  Submit: 'إرسال',
  'Review results': 'نتائج المراجعة',
  by: 'تم ذلك بواسطة ا',
  'DD.MM.YYYY HH:mm': 'YYYY/MM/DD HH:mm',
  'Decision on the application:': 'قرار بشأن التطبيق:',
  'Please examine the required information prior to determining whether to approve or decline the application of the client.':
    'يرجى مراجعة المعلومات المطلوبة قبل اتخاذ قرار بالموافقة على أو رفض تطبيق العميل.',
  'Previous steps must be submitted and valid before submitting completeReview':
    'يجب إرسال الخطوات السابقة والتحقق من صحتها قبل إرسال المراجعة النهائية',

  // Components
  'Enter your comment': 'أدخل تعليقك',

  // Managers step
  Manager: 'المدير',
  'Personal data': 'البيانات الشخصية',
  'Full name': 'الاسم الكامل',
  'Date of birth': 'تاريخ الميلاد',
  Nationality: 'الجنسية',
  Relation: 'العلاقة',
  'This person is a Politically Exposed Person (PEP)': 'هذا الشخص شخص مكشوف سياسيًا (PEP)',
  'Authorised Signatory Proof': 'إثبات التوقيع المخول',
  'This person is authorised signatory': 'هذا الشخص موقّع مخول',
  Email: 'البريد الإلكتروني',
  'Phone number': 'رقم الهاتف',
  'Document type': 'نوع المستند',
  'Authorised Signatory Proof Files': 'ملفات إثبات التوقيع المخول',
  'Authorised signatory proof type': 'نوع إثبات التوقيع المعتمد',
  'The purpose of the payment gateway': 'الغرض من بوابة الدفع',
  Passport: 'جواز سفر',
  'Document number': 'رقم المستند',
  'ID number': 'رقم الهوية',
  'Passport issue date': 'تاريخ إصدار جواز السفر',
  'Passport expiry date': 'تاريخ انتهاء صلاحية جواز السفر',
  'Personal Document': 'مستند شخصي',
  'ID type': 'نوع الهوية',
  'Document Number': 'رقم المستند',
  'Passport Number': 'رقم جواز السفر',
  'Passport number': 'رقم جواز السفر',
  Managers: 'المدراء',

  // Merchant step
  'Your application is under review': 'طلبك قيد المراجعة',
  'We aim to review all applications within 2 working days and we will notify you once your application has been approved.':
    'نهدف إلى مراجعة جميع الطلبات في غضون يومي عمل وسنشعرك بمجرد الموافقة على طلبك.',

  'Trigger Automated Screening': 'تشغيل الفحص الآلي',
  'Add manual screening': 'إضافة فحص يدوي',
  'Full match': 'تطابق كامل',
  'No matches': 'لا يوجد تطابق',
  'Partial match': 'تطابق جزئي',
  'Automated screening results': 'نتائج الفحص الآلي',
  'Automated screening is in progress. Please wait.': 'الفحص الآلي قيد التقدم. انتظر من فضلك.',
  'Manual verification is in progress. Please wait for the manual decision before reviewing the appplication.':
    'التحقق اليدوي قيد التقدم. يرجى انتظار القرار اليدوي قبل مراجعة الطلب.',
  'Manual screening results': 'نتائج الفحص اليدوي',
  'Screening resolution:': 'قرار الفحص',
  'Screening resolution': 'قرار الفحص',
  'Screening results': 'نتائج الفحص',
  'In case of complex ownership structure please provide comments and/or schemas that might be relevant.':
    'في حالة تعقيد هيكل الملكية، يرجى تقديم تعليقات و/أو مخططات قد تكون ذات صلة.',
  'Is your company directly or indirectly owned/managed by a natural person residing in a sanctioned country*?':
    'هل شركتك مملوكة أو مدارة بشكل مباشر أو غير مباشر من قبل شخص طبيعي مقيم في دولة خاضعة للعقوبات؟',
  'Does your company perform business / transactions on behalf of a third party?':
    'هل تقوم شركتك بإجراء أعمال / معاملات نيابة عن طرف ثالث؟',
  'Does your company have any subsidiary, branch, office or other presence in a sanctioned country?':
    'هل لشركتك أي فرع أو فرع أو مكتب أو وجود آخر في دولة خاضعة للعقوبات؟',
  'Does your company trade with the US or in goods that are US origin or in part contain goods of US origin?':
    'هل تتاجر شركتك مع الولايات المتحدة أو بالبضائع التي هي من أصل أمريكي أو تحتوي جزئيًا على بضائع من أصل أمريكي؟',
  'Does your company maintain any relationship with financial institution in a sanctioned country?':
    'هل لشركتك أي علاقة بمؤسسة مالية في دولة خاضعة للعقوبات؟',

  // High-risk reason tags
  'Business Structure from Thiqah': 'هيكل الأعمال من ثقة',
  'Business Activity (MCC)': 'نشاط الأعمال (MCC)',
  'Master MID Availability': 'توافر MID الرئيسي',
  'IBAN Verification Result': 'نتيجة التحقق من IBAN',
  'Compliance Questions': 'أسئلة الامتثال',
  'Screening Match': 'تطابق الفحص',

  // Agent Activity Log
  'Activity log': 'سجل النشاط',
  'Export all logs': 'تصدير جميع السجلات',
  'No changes': 'لا توجد تغييرات',
  'An error occurred while triggering the screening. Please try again.':
    'حدث خطأ أثناء تشغيل الفحص. يرجى المحاولة مرة أخرى.',
  'Trigger Screening Failed': 'فشل تشغيل الفحص',

  // Shareholders step
  'Additional information': 'معلومات إضافية',
  'ADDITIONAL INFORMATION': 'معلومات إضافية',
  'Additional information files': 'ملفات المعلومات الإضافية',
  Comment: 'تعليق',
  'Edit beneficial owner': 'تعديل المستفيد الفعلي',
  'First name': 'الاسم الأول',
  'Last name': 'الاسم الأخير',
  'Beneficial owner is a Politically Exposed Person (PEP)':
    'المستفيد الفعلي شخص مكشوف سياسيًا (PEP)',
  'Personal document': 'مستند شخصي',
  'Ownership share': 'حصة الملكية',
  'Shares, %': 'الأسهم، %',
  'Beneficial owners': 'المستفيدون الفعليون',
  'Individual Shareholder': 'مساهم فردي',
  'Legal Entity shareholder': 'مساهم جهة اعتبارية',
  'Company license': 'ترخيص الشركة',
  'Company legal name': 'الاسم القانوني للشركة',
  'Commercial Registration number': 'رقم السجل التجاري',
  'Entity number': 'رقم الكيان',
  'Ownership share:': 'حصة الملكية:',
  'Review shareholders': 'مراجعة المساهمين',
  'Individual shareholders': 'المساهمون الأفراد',
  'Legal entity shareholders': 'المساهمون الجهات الاعتبارية',
  'PERSONAL DOCUMENT': 'PERSONAL DOCUMENT',
  'In the meantime, you can head to our website to view more about our <1>products and services</1>.':
    'في هذه الأثناء، يمكنك التوجه إلى موقعنا الإلكتروني لعرض المزيد حول <1>منتجاتنا وخدماتنا</1>',
  'If you require any support whilst you wait, please <1>contact us</1>.':
    'إذا كنت بحاجة إلى أي دعم أثناء الانتظار، فيرجى <1>الاتصال بنا</1>.',
  'This person is listed on the Company License as part of the company ownership structure':
    'تم إدراج هذا الشخص في ترخيص الشركة كجزء من هيكل ملكية الشركة',
  'Upload a copy of the Power of Attorney showing this person as an authorised signatory':
    'قم بتحميل نسخة من التوكيل يوضح أن هذا الشخص مفوض بالتوقيع',
  'Country of incorporation': 'بلد التأسيس',
  'Shareholder Proof Document': 'وثيقة إثبات المساهم',
  MEMORANDUM: 'عقد التأسيس',
  ARTICLES: 'النظام الأساسي',
  'Minutes of board meetings': 'محاضر اجتماعات مجلس الإدارة',
  'Data of joint-stock companies listed in the financial market':
    'بيانات الشركات المساهمة المدرجة في السوق المالي',

  // POS UI Changes — Product Summary & Merchant Details (Part 2 & 3)
  'Product Summary': 'ملخص المنتجات',
  'E-commerce': 'التجارة الإلكترونية',
  'No products selected': 'لم يتم اختيار أي منتج',
  'Automated Screening': 'الفحص الآلي',
  'Merchant Details': 'تفاصيل التاجر',
  // Business Details step — commercial name changes per spec
  'Company Commercial Name [En]': 'الاسم التجاري للشركة [إنجليزي]',
  'Company Commercial Name [Ar]': 'الاسم التجاري للشركة [عربي]',
  'Company Commercial Name [En] – Agent Updates': 'الاسم التجاري [إنجليزي] – تحديثات الوكيل',
  'Company Commercial Name [Ar] – Agent Updates': 'الاسم التجاري [عربي] – تحديثات الوكيل',
  'Enter English commercial name': 'أدخل الاسم التجاري بالإنجليزية',
  'Enter Arabic commercial name': 'أدخل الاسم التجاري بالعربية',
  'Arabic letters are not allowed': 'الحروف العربية غير مسموحة',
  'English letters are not allowed': 'الحروف الإنجليزية غير مسموحة',
  'City [Retrieved from Thiqah]': 'المدينة [من ثقة]',
  'City [Merchant Submission]': 'المدينة [طلب التاجر]',
  'Merchant Name (English)': 'اسم التاجر (بالإنجليزية)',
  'Merchant Name (Arabic)': 'اسم التاجر (بالعربية)',
  'Store Address (English)': 'عنوان المتجر (بالإنجليزية)',
  'Store Address (Arabic)': 'عنوان المتجر (بالعربية)',
  'City (Business Details)': 'المدينة (تفاصيل النشاط التجاري)',
  // Product Selected panel
  'Product Selected': 'المنتج المختار',
  'POS Terminal': 'نقطة البيع',
  'POS terminal': 'نقطة البيع',

  // Risk Questionnaire review step
  'Risk Questionnaire': 'استبيان المخاطر',
  'Expected number of transactions per month': 'العدد المتوقع للمعاملات شهريًا',
  'Expected monthly sales amount ({SAR})': 'قيمة المبيعات الشهرية المتوقعة ({SAR})',
  'Expected average transaction value ({SAR})': 'متوسط قيمة المعاملة المتوقع ({SAR})',
  'Expected annual revenue ({SAR})': 'الإيرادات السنوية المتوقعة ({SAR})',

  // Company Information — Company Details section
  'Company legal name – Agent Updates': 'الاسم القانوني للشركة – تحديثات الوكيل',
  'Please enter the English company legal name': 'يرجى إدخال الاسم القانوني للشركة بالإنجليزية',
  'Please enter the English company commercial name': 'يرجى إدخال الاسم التجاري للشركة بالإنجليزية',
  'Form Name': 'اسم النموذج',
  'Company Characters': 'أوصاف الشركة',
  'License Issuer Name': 'اسم جهة الترخيص',
  'Partners Nationality Name': 'جنسية الشركاء',
  'Is Main': 'السجل الرئيسي',
  'Parent Company License Number': 'رقم ترخيص الشركة الأم',
  'In Liquidation Process': 'في عملية التصفية',
  'Please enter CR status': 'يرجى إدخال حالة السجل التجاري',
  'Date of Establishment': 'تاريخ التأسيس',
  'Company Period [In Years]': 'مدة الشركة (بالسنوات)',
  'Reactivation Date': 'تاريخ إعادة التفعيل',
  'Suspension Date – Agent Updates': 'تاريخ التعليق – تحديثات الوكيل',
  'Deletion Date': 'تاريخ الحذف',
  'Company Phone Number': 'رقم هاتف الشركة',
  'Please enter company phone number': 'يرجى إدخال رقم هاتف الشركة',
  'Enter company phone number': 'أدخل رقم هاتف الشركة',
  'Company Mobile Number': 'رقم جوال الشركة',
  'Please enter company mobile number': 'يرجى إدخال رقم جوال الشركة',
  'Enter company mobile number': 'أدخل رقم جوال الشركة',
  'Applicant Mobile Number': 'رقم جوال مقدم الطلب',
  'Applicant mobile number': 'رقم جوال مقدم الطلب',
  'Website URL': 'رابط الموقع الإلكتروني',
  'Please enter website URL': 'يرجى إدخال رابط الموقع الإلكتروني',
  'Enter website URL': 'أدخل رابط الموقع الإلكتروني',
  'E-commerce Merchant': 'تاجر التجارة الإلكترونية',
  'Select Yes or No': 'اختر نعم أو لا',
  'Authentication Platforms': 'منصات المصادقة',
  'Store Url': 'رابط المتجر',
  'Store Activities': 'أنشطة المتجر',

  // Company Information — National Address section
  'National Address': 'العنوان الوطني',
  'National address requires agent review': 'العنوان الوطني يتطلب مراجعة الموظف',
  'Complete mandatory national address fields before approval.':
    'يرجى استكمال حقول العنوان الوطني الإلزامية قبل الموافقة.',
  'National Address Certificate': 'شهادة العنوان الوطني',
  'National Address – Postal Code': 'العنوان الوطني – الرمز البريدي',
  'Enter postal code': 'أدخل الرمز البريدي',
  'Please enter postal code': 'يرجى إدخال الرمز البريدي',
  'Enter building number': 'أدخل رقم المبنى',
  'Please enter building number': 'يرجى إدخال رقم المبنى',
  'Enter additional number': 'أدخل الرقم الإضافي',
  'Please enter additional number': 'يرجى إدخال الرقم الإضافي',
  'Enter unit number': 'أدخل رقم الوحدة',
  'Please enter unit number': 'يرجى إدخال رقم الوحدة',
  'Enter street name': 'أدخل اسم الشارع',
  'Please enter street name': 'يرجى إدخال اسم الشارع',
  'Enter district name': 'أدخل اسم الحي',
  'Please enter district name': 'يرجى إدخال اسم الحي',
  'Regular Address (Full Address)': 'العنوان العادي (العنوان الكامل)',
  'Enter full address': 'أدخل العنوان الكامل',
  'Please enter full address': 'يرجى إدخال العنوان الكامل',
  'National Address – Merchant Name': 'العنوان الوطني – اسم التاجر',
  'Enter merchant name': 'أدخل اسم التاجر',
  'National Address – City': 'العنوان الوطني – المدينة',
  'Enter city': 'أدخل المدينة',
  'National Address – Region Name': 'العنوان الوطني – اسم المنطقة',
  'Enter region name': 'أدخل اسم المنطقة',
  'National Address – Address ID': 'العنوان الوطني – معرف العنوان',
  'Enter address ID': 'أدخل معرف العنوان',
  'National Address – Status': 'العنوان الوطني – الحالة',
  'Enter status': 'أدخل الحالة',

  // Company Information — Capital section
  'CR capital': 'رأس مال السجل التجاري',
  'Please enter capital amount': 'يرجى إدخال مبلغ رأس المال',
  'Enter capital amount': 'أدخل مبلغ رأس المال',
  'Contribution Capital Type': 'نوع رأس مال المساهمة',
  'Contribution Capital Cash': 'رأس مال المساهمة النقدي',
  'Contribution Capital inKind': 'رأس مال المساهمة العيني',
  'Contribution Value': 'قيمة المساهمة',
  'Contribution Capital Total Cash': 'إجمالي رأس مال المساهمة النقدي',
  'Contribution Capital Total inKind': 'إجمالي رأس مال المساهمة العيني',
  'Stock Capital Type': 'نوع رأس المال السهمي',
  'Stock Capital Value': 'قيمة رأس المال السهمي',
  'Stock Capital Cash': 'رأس المال السهمي النقدي',
  'Stock Capital InKind': 'رأس المال السهمي العيني',
  'Announced Stock Capital': 'رأس المال السهمي المعلن',
  'Paid Stock Capital': 'رأس المال السهمي المدفوع',
  'Shares Price': 'سعر السهم',

  // Company Information — Fiscal Year section
  'Enter calendar type': 'أدخل نوع التقويم',

  // Company Information — Main Business Nature section
  'Main Business Activity': 'النشاط التجاري الرئيسي',
  'Search activities...': 'ابحث عن الأنشطة...',
  'No results found': 'لا توجد نتائج',
  Previous: 'السابق',
  of: 'من',
  Next: 'التالي',
  'Master MID': 'MID الرئيسي',
  'Master TID': 'TID الرئيسي',

  // Company Information — Tax section
  'Tax Registration Number': 'رقم التسجيل الضريبي',

  // Company Questionnaire review page
  'Are you, or a direct family member, or any individual associated with your business, a Politically Exposed Person (PEP)?':
    'هل أنت، أو أحد أفراد أسرتك المباشرين، أو أي شخص مرتبط بنشاطك التجاري، شخصٌ مكشوف سياسيًا (PEP)؟',
  'Name of Politically Exposed Person': 'اسم الشخص المكشوف سياسيًا',
  'Do your business activities, owners, or officials have any direct or indirect involvement with, or interests in, any sanctioned countries, territories, or individuals/entities listed on sanctions lists? \nThis includes any current operations, offices, financial relationships, or planned engagements that may contravene applicable sanctions regulations.':
    'هل لأنشطتك التجارية أو مالكيها أو مسؤوليها أي تورط مباشر أو غير مباشر، أو مصالح في أي دول أو أقاليم خاضعة للعقوبات، أو أفراد أو كيانات مدرجة في قوائم العقوبات؟\nيشمل ذلك أي عمليات أو مكاتب أو علاقات مالية قائمة أو مشاركات مخطط لها قد تخالف لوائح العقوبات المعمول بها.',
  'the countries, individuals, business activities, goods/services involved (including their use, origin, and destination)':
    'الدول والأفراد والأنشطة التجارية والسلع/الخدمات المعنية (بما في ذلك استخدامها ومصدرها ووجهتها)',

  // Manager & Shareholder review — PersonReviewFormItems
  'Full name – Agent Updates': 'الاسم الكامل – تحديثات الوكيل',
  'Nationality – Agent Updates': 'الجنسية – تحديثات الوكيل',
  'Please enter the English full name': 'يرجى إدخال الاسم الكامل بالإنجليزية',
  'Please select the nationality': 'يرجى اختيار الجنسية',
  'Manager Relationship Type': 'نوع علاقة المدير',
  'Please enter the relationship type': 'يرجى إدخال نوع العلاقة',
  'Enter relationship type': 'أدخل نوع العلاقة',
  'ID Number – Agent Update': 'رقم الهوية – تحديث الوكيل',
  'Please enter the ID type': 'يرجى إدخال نوع الهوية',
  'Enter ID type': 'أدخل نوع الهوية',
  'Please enter the ID number': 'يرجى إدخال رقم الهوية',
  'Enter ID number': 'أدخل رقم الهوية',

  // Individual Shareholder review — ownership share section
  'Shares %': 'نسبة الأسهم %',
  'Enter shares %': 'أدخل نسبة الأسهم %',
  'Enter shares count': 'أدخل عدد الأسهم',
  'Share Type': 'نوع الحصة',
  'Enter share type': 'أدخل نوع الحصة',
  'Entity Relationship Type': 'نوع علاقة الكيان',
  'Enter entity relationship type': 'أدخل نوع علاقة الكيان',
  'Download File': 'تحميل الملف',
  'review.contractReview': 'الاتفاقية',
  contractReview: 'الاتفاقية',
  Agreement: 'الاتفاقية',
  'National Address Missing': 'العنوان الوطني مفقود',

  // ── تمارا / تابي — لوحة القراءة فقط في بوابة الوكيل ──────────────────────────
  'Additional Payment Options': 'خيارات الدفع الإضافية',
  'Tamara': 'تمارا',
  'Tabby': 'تابي',
};
